<template>
  <div>
    <template v-if="readOnly"> {{ text }} </template
    ><template v-else>
      <v-text-field
        v-bind="$attrs"
        v-on="$listeners"
        :placeholder="config.PLACEHOLDER_SP"
        dense
        class="mt-2"
        :disabled="facilityStatus.read_only_row"
        :maxlength="maxlength"
        @keypress="keyPress($event)"
        @blur="blur($event)"
        @keyup="keyUp($event)"
        type="tel"
        ref="text"
        ><slot
      /></v-text-field>
    </template>
  </div>
</template>

<script>
import config from "@/js/const";
export default {
  name: "EvaFacilityStatusListTextField",
  inheritAttrs: false,
  props: {
    readOnly: {
      type: Boolean,
      default: true
    },
    text: {
      type: String
    },
    facilityStatus: {
      type: Object,
      default: undefined
    },
    maxlength: {
      type: Number,
      default: 4
    }
  },
  data: () => ({
    config: config
  }),
  methods: {
    // 入力値が数値以外（空白除く）の場合は、「０」で返す
    keyPress(e) {
      this.keyUp(e);
    },
    blur(e) {
      this.keyUp(e);
    },
    keyUp(e) {
      let num = parseInt(e.target.value);
      if (e.target.value == "") {
        this.$emit("input", "");
      } else if (Number.isNaN(num) || num < 0) {
        this.$emit("input", "0");
      } else {
        this.$emit("input", `${num}`);
      }
    }
  }
};
</script>
